const prefix = 'nxt';
const iconName = 'merge';
const width = 13;
const height = 17;
const ligatures = [];
const unicode = '';
const svgPathData =
  'M12.6996 16.7C13.0896 16.31 13.0896 15.68 12.6996 15.29L9.99957 12.59L8.58957 14L11.2896 16.7C11.6796 17.09 12.3196 17.09 12.6996 16.7ZM3.70957 4.99996H5.99957V10.59L1.28957 15.29C0.89957 15.68 0.89957 16.31 1.28957 16.7C1.67957 17.09 2.30957 17.09 2.69957 16.7L7.40957 12C7.78957 11.62 7.99957 11.12 7.99957 10.59V4.99996H10.2896C10.7396 4.99996 10.9596 4.45996 10.6396 4.14996L7.34957 0.859961C7.14957 0.659961 6.83957 0.659961 6.63957 0.859961L3.34957 4.14996C3.03957 4.45996 3.25957 4.99996 3.70957 4.99996Z';

const definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [width, height, ligatures, unicode, svgPathData],
};

const nxtMerge = definition;

export { definition, nxtMerge, prefix, iconName, width, height, ligatures, unicode, svgPathData };
